import styles from "./companyreview.module.scss";

type CompanyDescriptionProps = {
  name: string;
  logo: string;
  description: string;
};

const CompanyDescription: React.FC<CompanyDescriptionProps> = ({
  name,
  logo,
  description,
}) => {
  return (
    <div className={styles.companyDescription}>
      <div className={styles.companyDescriptionInner}>
        <h4 className={styles.companyName}>About {name}</h4>
        <div className={styles.companyData}>
          <div className={styles.logoContainer}>
            <img src={logo} alt="Company logo" />
          </div>
          <div className={styles.description}>
            <p>{description}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompanyDescription;
